import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { HubConnectionBuilder, HubConnectionState } from '@aspnet/signalr';
import { compress, decompress } from 'compress-json';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { Message } from '../models/Message';
import { ReservationModel } from '../models/ShuttleReservationsViewmodel';
import { AuthService } from './auth.service';
import { MyLogger } from './MyLogger';

export interface Reservations {
  created: Date;
  reservations: ReservationModel[];
}

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  public hasStarted = false;
  public myLogger: MyLogger = new MyLogger();
  private hubConnection: signalR.HubConnection;
  private hostPath: string = JSON.parse(environment.IDENTITY);
  public showDepartFlightDeparted = false;
  public showDepartTransitCompleted = false;
  public chatActive = false;
  messageReceived = new EventEmitter<Message>();
  connectionEstablished = new EventEmitter<Boolean>();
  public hubConnectionId = '';
  carArrivedParking = new EventEmitter<number>();
  pickedUpFromParking = new EventEmitter<number>();
  droppedAtAirport = new EventEmitter<number>();
  pickedUpFromAirport = new EventEmitter<number>();
  droppedAtParking = new EventEmitter<number>();
  carLeftParking = new EventEmitter<number>();
  transferReservationList = new EventEmitter<Reservations>();
  public showTravelAgentSubject = new Subject<boolean>();
  showTravelAgent$ = this.showTravelAgentSubject.asObservable();
  storedReservationList: any;

  constructor(private authService: AuthService, private authHttp: HttpClient) {
    if (localStorage.getItem('showDepartFlightDeparted') != null) {
      this.showDepartFlightDeparted = JSON.parse(localStorage.getItem('showDepartFlightDeparted'));
    }

    if (localStorage.getItem('showDepartTransitCompleted') != null) {
      this.showDepartTransitCompleted = JSON.parse(localStorage.getItem('showDepartTransitCompleted'));
    }

    if (localStorage.getItem('chatActive') != null) {
      this.chatActive = JSON.parse(localStorage.getItem('chatActive'));
    }
  }

  showTravelAgent(showTravelAgent: boolean) {
    this.showTravelAgentSubject.next(showTravelAgent);
  }

  getStoredReservations() {
    // console.log('getStoredReservations');
    if (this.storedReservationList == null) {
      // this.storedReservationList = JSON.parse(localStorage.getItem('transferReservationList'));
      this.storedReservationList = decompress(
        JSON.parse(localStorage.getItem('transferReservationList'))
      );

      // console.log('getStoredReservations from storage', this.storedReservationList);
    }

    if (this.storedReservationList != null) {
      // console.log('getStoredReservations from service', this.storedReservationList);
      this.transferReservationList.emit(this.storedReservationList);
    }
  }

  public startConnection = () => {
    if (this.authService.loggedIn()) {
      if (!this.hasStarted) {
        this.hasStarted = true;
        const self = this;
        this.hubConnection = new HubConnectionBuilder()
          .withUrl(this.hostPath + 'shuttlebussHub', {
            accessTokenFactory: () => this.authService.getToken()
          })
          .configureLogging(this.myLogger)
          .build();
        this.hubConnection
          .start()
          .then(() => {
            // console.log('ShuttlebussHub: Connection started');
            this.connectionEstablished.emit(true);
            this.handleFailures(self);
            self.registerOnServerEvents();
          })
          .catch(err => {
            self.hasStarted = false;
            // console.log('ShuttlebussHub: Error while establishing connection, retrying...');
            setTimeout(function() {
              // if (self.authService.loggedIn()) {
              self.startConnection();
              // }
            }, 5000);
          });
      }
    } else {
      // console.log(
      //   'ShuttlebussHub: User not logged in, waiting for 5 seconds and try to start connection again'
      // );
      const self = this;
      setTimeout(function() {
        self.startConnection();
      }, 5000);
    }
  };

  public stopConnection = () => {
    this.hubConnection.stop();
  };

  public handleFailures(self) {
    self.hubConnection.onclose(function() {
      self.hasStarted = false;
      self.startConnection();
    });
  }

  public getConnectionState(): string {
    if (this.hubConnection) {
      return HubConnectionState[this.hubConnection.state];
    } else {
      return 'Unitialized';
    }
  }

  public showDeparturesFlightsDeparted() {
    this.showDepartFlightDeparted = true;
    localStorage.setItem('showDepartFlightDeparted', JSON.stringify(this.showDepartFlightDeparted));
    this.getStoredReservations();
  }
  public hideDeparturesFlightsDeparted() {
    this.showDepartFlightDeparted = false;
    localStorage.setItem('showDepartFlightDeparted', JSON.stringify(this.showDepartFlightDeparted));
    this.getStoredReservations();
  }

  public showDeparturesTransitCompleted() {
    this.showDepartTransitCompleted = true;
    localStorage.setItem(
      'showDepartTransitCompleted',
      JSON.stringify(this.showDepartTransitCompleted)
    );
    this.getStoredReservations();
  }
  public hideDeparturesTransitCompleted() {
    this.showDepartTransitCompleted = false;
    localStorage.setItem(
      'showDepartTransitCompleted',
      JSON.stringify(this.showDepartTransitCompleted)
    );
    this.getStoredReservations();
  }

  public showChat() {
    this.chatActive = true;
    localStorage.setItem(
      'chatActive',
      JSON.stringify(this.chatActive)
    );
  }
  public hideChat() {
    this.chatActive = false;
    localStorage.setItem(
      'chatActive',
      JSON.stringify(this.chatActive)
    );
  }

  sendMessage(message: Message) {
    this.hubConnection.invoke('NewMessage', message);
  }
  CarArrivedParking(reservationId: number) {
    this.hubConnection.invoke('CarArrivedParking', reservationId);
  }
  PickedUpFromParking(reservationId: number) {
    this.hubConnection.invoke('PickedUpFromParking', reservationId);
  }
  DroppedAtAirport(reservationId: number) {
    this.hubConnection.invoke('DroppedAtAirport', reservationId);
  }
  PickedUpFromAirport(reservationId: number) {
    this.hubConnection.invoke('PickedUpFromAirport', reservationId);
  }
  DroppedAtParking(reservationId: number) {
    this.hubConnection.invoke('DroppedAtParking', reservationId);
  }
  CarLeftParking(reservationId: number) {
    this.hubConnection.invoke('CarLeftParking', reservationId);
  }

  public registerOnServerEvents(): void {
    this.hubConnection.on('MessageReceived', (data: any) => {
      // console.log('MessageReceived:', data);
      this.messageReceived.emit(data);
    });
    this.hubConnection.on('CarArrivedParking', (data: any) => {
      // console.log('CarArrivedParking:', data);
      this.carArrivedParking.emit(data);
    });
    this.hubConnection.on('PickedUpFromParking', (data: any) => {
      // console.log('PickedUpFromParking:', data);
      this.pickedUpFromParking.emit(data);
    });
    this.hubConnection.on('DroppedAtAirport', (data: any) => {
      // console.log('DroppedAtAirport:', data);
      this.droppedAtAirport.emit(data);
    });
    this.hubConnection.on('PickedUpFromAirport', (data: any) => {
      // console.log('PickedUpFromAirport:', data);
      this.pickedUpFromAirport.emit(data);
    });
    this.hubConnection.on('DroppedAtParking', (data: any) => {
      // console.log('DroppedAtParking:', data);
      this.droppedAtParking.emit(data);
    });
    this.hubConnection.on('CarLeftParking', (data: any) => {
      // console.log('CarLeftParking:', data);
      this.carLeftParking.emit(data);
    });
    this.hubConnection.on('transferReservationList', (transferReservationList: Reservations) => {
      const compressed = compress(transferReservationList);
      // localStorage.setItem('transferReservationList', JSON.stringify(transferReservationList));
      // console.log('TransferReservationList Save Start', transferReservationList);
      localStorage.setItem('transferReservationList', JSON.stringify(compressed));
      this.storedReservationList = transferReservationList;
      // console.log('TransferReservationList Save End', transferReservationList);

      this.transferReservationList.emit(transferReservationList);
    });
  }
}
